<template>
  <div>
    <v-card class="pa-4 ma-3 main-card">
      <div class="my-1 mx-3">
        <div class="d-flex align-end">
          <div class="icon-back">
            <v-icon id="icon" size="37" color="white">
              mdi-chart-areaspline
            </v-icon>
          </div>

          <v-toolbar-title class="main-title">
            {{ $t('Cronograma') }}
          </v-toolbar-title>

          <div class="ml-6 color-container">
            <div class="d-flex align-end">
              <div class="executed-ondate-color"></div>
              {{ $t('Agendada') }}: {{ result.scheduledCount }}
            </div>
            <div class="d-flex align-end">
              <div class="schedule-color"></div>
              {{ $t('Executada dentro do prazo') }}:
              {{ result.executedWithinTheDeadlineCount }}
            </div>
            <div class="d-flex align-end">
              <div class="executed-offdate-color"></div>
              {{ $t('Executada fora do prazo') }}:
              {{ result.executedAfterDeadlineCount }}
            </div>
            <div class="d-flex align-end">
              <div class="executed-outside-month-color"></div>
              {{ $t('Atrasada') }}: {{ result.lateCount }}
            </div>
          </div>
        </div>
      </div>

      <v-simple-table class="mt-2 custom-table mx-3 mb-6" fixed-header>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left" v-if="content.isBigData">Instituição</th>
              <th class="text-left">{{ $t('Identificação') }}</th>
              <th class="text-left">{{ $t('Patrimônio') }}</th>
              <th class="text-left">{{ $t('Nº Série') }}</th>
              <th class="text-left">{{ $t('Equipamento') }}</th>
              <th class="text-left">{{ $t('Fabricante') }}</th>
              <th class="text-left">{{ $t('Modelo') }}</th>
              <th class="text-left">{{ $t('Oficina') }}</th>
              <th class="text-left">{{ $t('Unidade') }}</th>
              <th class="text-left">{{ $t('Setor') }}</th>
              <th class="text-center">{{ $t('Tipo OS') }}</th>
              <th class="text-left">{{ $t('Resp.') }}</th>
              <th class="text-left">{{ $t('Responsável') }}</th>
              <th class="text-center">{{ $t('Jan') }}</th>
              <th class="text-center">{{ $t('Fev') }}</th>
              <th class="text-center">{{ $t('Mar') }}</th>
              <th class="text-center">{{ $t('Abr') }}</th>
              <th class="text-center">{{ $t('Mai') }}</th>
              <th class="text-center">{{ $t('Jun') }}</th>
              <th class="text-center">{{ $t('Jul') }}</th>
              <th class="text-center">{{ $t('Ago') }}</th>
              <th class="text-center">{{ $t('Set') }}</th>
              <th class="text-center">{{ $t('Out') }}</th>
              <th class="text-center">{{ $t('Nov') }}</th>
              <th class="text-center">{{ $t('Dez') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in content.data" :key="index">
              <td v-if="content.isBigData">{{ item.institution }}</td>
              <td>
                {{ item.identification }}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      text
                      color="#0F3565"
                      :href="`/editServiceOrder/${item.openOrderId}`"
                      target="_blank"
                      v-bind="attrs"
                      v-on="on"
                      v-if="item.openOrderId"
                    >
                      <v-icon> mdi-exclamation-thick </v-icon>
                    </v-btn>
                  </template>
                  <span>Em manutenção corretiva! Clique para acessar</span>
                </v-tooltip>
              </td>
              <td>{{ item.propertyCode }}</td>
              <td>{{ item.serialNumber }}</td>
              <td>{{ item.equipmentName }}</td>
              <td>{{ item.manufacturer }}</td>
              <td>{{ item.model }}</td>
              <td>{{ item.workshop }}</td>
              <td>{{ item.unidade }}</td>
              <td>{{ item.departmentName }}</td>
              <td class="text-center">{{ $t(item.serviceOrderType) }}</td>
              <td class="text-lef">
                {{ $t(item.responsability) }}
              </td>
              <td class="text-left">
                {{ item.responsible }}
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorJan
                      ? item.backgroundColorJan
                      : 'transparent'
                  "
                  v-if="item.serviceOrderJanId"
                  :href="redirectJan(item)"
                  target="_blank"
                >
                  {{ item.jan }}
                </v-btn>
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorFev
                      ? item.backgroundColorFev
                      : 'transparent'
                  "
                  v-if="item.serviceOrderFevId"
                  :href="redirectFev(item)"
                  target="_blank"
                >
                  {{ item.fev }}
                </v-btn>
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorMar
                      ? item.backgroundColorMar
                      : 'transparent'
                  "
                  v-if="item.serviceOrderMarId"
                  :href="redirectMar(item)"
                  target="_blank"
                >
                  {{ item.mar }}
                </v-btn>
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorAbr
                      ? item.backgroundColorAbr
                      : 'transparent'
                  "
                  v-if="item.serviceOrderAbrId"
                  :href="redirectAbr(item)"
                  target="_blank"
                >
                  {{ item.abr }}
                </v-btn>
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorMai
                      ? item.backgroundColorMai
                      : 'transparent'
                  "
                  v-if="item.serviceOrderMaiId"
                  :href="redirectMai(item)"
                  target="_blank"
                >
                  {{ item.mai }}
                </v-btn>
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorJun
                      ? item.backgroundColorJun
                      : 'transparent'
                  "
                  v-if="item.serviceOrderJunId"
                  :href="redirectJun(item)"
                  target="_blank"
                >
                  {{ item.jun }}
                </v-btn>
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorJul
                      ? item.backgroundColorJul
                      : 'transparent'
                  "
                  v-if="item.serviceOrderJulId"
                  :href="redirectJul(item)"
                  target="_blank"
                >
                  {{ item.jul }}
                </v-btn>
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorAgo
                      ? item.backgroundColorAgo
                      : 'transparent'
                  "
                  v-if="item.serviceOrderAgoId"
                  :href="redirectAgo(item)"
                  target="_blank"
                >
                  {{ item.ago }}
                </v-btn>
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorSet
                      ? item.backgroundColorSet
                      : 'transparent'
                  "
                  v-if="item.serviceOrderSetId"
                  :href="redirectSet(item)"
                  target="_blank"
                >
                  {{ item.set }}
                </v-btn>
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorOut
                      ? item.backgroundColorOut
                      : 'transparent'
                  "
                  v-if="item.serviceOrderOutId"
                  :href="redirectOut(item)"
                  target="_blank"
                >
                  {{ item.out }}
                </v-btn>
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorNov
                      ? item.backgroundColorNov
                      : 'transparent'
                  "
                  v-if="item.serviceOrderNovId"
                  :href="redirectNov(item)"
                  target="_blank"
                >
                  {{ item.nov }}
                </v-btn>
              </td>
              <td class="text-center">
                <v-btn
                  height="41"
                  small
                  depressed
                  :color="
                    item.backgroundColorDez
                      ? item.backgroundColorDez
                      : 'transparent'
                  "
                  v-if="item.serviceOrderDezId"
                  :href="redirectDez(item)"
                  target="_blank"
                >
                  {{ item.dez }}
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import ApiService from '../../../services/ApiService'
export default {
  name: 'Schedule',

  created() {
    const filters = JSON.parse(localStorage.getItem('scheduleFilters'))
    this.list(filters)
  },

  mounted() {
    setTimeout(() => {
      const slider = document.querySelector(
        '.custom-table .v-data-table__wrapper'
      )
      let isDown = false
      let startX
      let scrollLeft

      slider.addEventListener('mousedown', (e) => {
        isDown = true
        slider.classList.add('active')
        startX = e.pageX - slider.offsetLeft
        scrollLeft = slider.scrollLeft
      })
      slider.addEventListener('mouseleave', () => {
        isDown = false
        slider.classList.remove('active')
      })
      slider.addEventListener('mouseup', () => {
        isDown = false
        slider.classList.remove('active')
      })
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return
        e.preventDefault()
        const x = e.pageX - slider.offsetLeft
        const walk = (x - startX) * 3 //scroll-fast
        slider.scrollLeft = scrollLeft - walk
      })
    }, 2000)
  },

  data() {
    return {
      result: {},
      apiService: new ApiService(),
      content: [],
    }
  },

  methods: {
    redirectJan(item) {
      let url = `/editServiceOrder/${item.serviceOrderJanId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderJanId}/${item.institutionId}`
      }

      if (item.jan && item.jan.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=1&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    redirectFev(item) {
      let url = `/editServiceOrder/${item.serviceOrderFevId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderFevId}/${item.institutionId}`
      }

      if (item.fev && item.fev.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=2&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    redirectMar(item) {
      let url = `/editServiceOrder/${item.serviceOrderMarId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderMarId}/${item.institutionId}`
      }

      if (item.mar && item.mar.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=3&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    redirectAbr(item) {
      let url = `/editServiceOrder/${item.serviceOrderAbrId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderAbrId}/${item.institutionId}`
      }

      if (item.abr && item.abr.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=4&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    redirectMai(item) {
      let url = `/editServiceOrder/${item.serviceOrderMaiId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderMaiId}/${item.institutionId}`
      }

      if (item.mai && item.mai.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=5&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    redirectJun(item) {
      let url = `/editServiceOrder/${item.serviceOrderJunId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderJunId}/${item.institutionId}`
      }

      if (item.jun && item.jun.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=6&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    redirectJul(item) {
      let url = `/editServiceOrder/${item.serviceOrderJulId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderJulId}/${item.institutionId}`
      }

      if (item.jul && item.jul.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=7&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    redirectAgo(item) {
      let url = `/editServiceOrder/${item.serviceOrderAgoId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderAgoId}/${item.institutionId}`
      }

      if (item.ago && item.ago.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=8&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    redirectSet(item) {
      let url = `/editServiceOrder/${item.serviceOrderSetId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderSetId}/${item.institutionId}`
      }

      if (item.set && item.set.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=9&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    redirectOut(item) {
      let url = `/editServiceOrder/${item.serviceOrderOutId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderOutId}/${item.institutionId}`
      }

      if (item.out && item.out.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=10&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    redirectNov(item) {
      let url = `/editServiceOrder/${item.serviceOrderNovId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderNovId}/${item.institutionId}`
      }

      if (item.nov && item.nov.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=11&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    redirectDez(item) {
      let url = `/editServiceOrder/${item.serviceOrderDezId}`

      if (this.content.isBigData) {
        url = `/bigData-editServiceOrder/${item.serviceOrderDezId}/${item.institutionId}`
      }

      if (item.dez && item.dez.includes('+')) {
        url = `/listServiceOrders?equipment=${item.equipmentId}&month=12&year=${this.content.year}&type=${item.serviceOrderType}`
      }

      return url
    },

    async list(filters) {
      let url = 'serviceOrder/scheduleExport'
      if (filters.isBigData) {
        url = 'bigdata/scheduleExport'
      }

      await this.apiService
        .post(url, filters)
        .then((response) => {
          this.content = response.content.orders
          this.result = response.content
        })
        .catch((err) => {})
    },
  },
}
</script>

<style>
.v-data-table__wrapper::-webkit-scrollbar {
  background-color: #fff !important;
  opacity: 0.6 !important;
  height: 35px;
  width: 35px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: #ccc !important;
  opacity: 0.8 !important;
  border: 14px solid #fff !important;
  height: 5px !important;
  border-radius: 20px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #888 !important;
  opacity: 0.6 !important;
}
</style>

<style scoped>
.schedule-color,
.executed-ondate-color,
.executed-offdate-color,
.executed-outside-month-color {
  width: 60px;
  height: 20px;
  padding: 6px;
  margin: 1px 6px;
  border: 2px solid #ccc;
  border-radius: 4px;
}

.color-container {
  font-size: 12px;
  font-weight: 700;
}

.schedule-color {
  background: #b9ce1e;
}

.executed-ondate-color {
  background: #ffd21f;
}

.executed-offdate-color {
  background: #3c8ea6;
}

.executed-outside-month-color {
  background: #ff4f64;
}

.custom-table thead tr th {
  padding-left: 16px !important;
  background: #2a8ea4 !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 16px !important;
  color: #ffffff !important;
  min-width: 90px;
}

.custom-table thead tr th:first-child {
  border-radius: 4px 0 0 4px !important;
}

.custom-table thead tr th:last-child {
  padding-right: 16px !important;
  border-radius: 0 4px 4px 0 !important;
}

.custom-table tbody tr td:last-child {
  padding-right: 16px !important;
  border-radius: 0 4px 4px 0 !important;
}

.custom-table tbody tr td {
  padding: 4px 0 4px 14px !important;
  font-weight: 300 !important;
  font-size: 12px !important;
  line-height: 15px !important;
  letter-spacing: 0.15px !important;
  color: #808080 !important;
}

.custom-table tbody tr td .v-btn {
  color: #202020 !important;
}

.main-card {
  z-index: 16 !important;
  background: #ffffff;
  box-shadow: 0px 5px 16px rgba(0, 0, 0, 0.05) !important;
  border-radius: 8px;
}

.icon-back {
  width: 60px;
  height: 54px;
  background: #b9ce1e;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-title {
  margin-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  /* identical to box height */

  color: #000000;
}
</style>
